__turbopack_context__.v({
  "container": "notificationListItem-module-scss-module__QyR-mG__container",
  "container-left": "notificationListItem-module-scss-module__QyR-mG__container-left",
  "container-left-content": "notificationListItem-module-scss-module__QyR-mG__container-left-content",
  "container-left-title": "notificationListItem-module-scss-module__QyR-mG__container-left-title",
  "container-right": "notificationListItem-module-scss-module__QyR-mG__container-right",
  "container-selected": "notificationListItem-module-scss-module__QyR-mG__container-selected",
  "container-unread": "notificationListItem-module-scss-module__QyR-mG__container-unread",
  "container-unread-border": "notificationListItem-module-scss-module__QyR-mG__container-unread-border",
});
